import React from "react";

function AboutMeSection() {
  return <div></div>;
}

export default AboutMeSection;
